import firebase from "./firebaseInit";

export const db = firebase.firestore()
export const firestore = firebase.firestore
export const FieldValue = firebase.firestore.FieldValue
export const blogsRef = db.collection("Blogs")
export const personsRef = db.collection("Persons")
export const personsBkpRef = db.collection("PersonsBkp")
export const reviewsRef = db.collection("Reviews")